import gsap from '@lib/gsap'

export default function (element, dataset = {}) {
  const btns = gsap.utils.toArray('[data-tabs-btn]', element)
  const contents = gsap.utils.toArray('[data-tabs-content]', element)

  btns[0].classList.add('is-active')
  gsap.set(contents, { autoAlpha: 0, position: 'absolute', top: 0 })
  gsap.set(contents[0], { autoAlpha: 1, position: 'relative' })

  let currentBtn = btns[0]
  let currentContent = contents[0]

  btns.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      if (btn === currentBtn) return

      btn.classList.add('is-active')
      currentBtn.classList.remove('is-active')

      gsap.to(currentContent, {
        autoAlpha: 0,
        duration: 0.5,
        ease: 'power2.out',
        onComplete: () => {
          gsap.to(contents[index], { autoAlpha: 1, duration: 0.5, ease: Power2.out })
        },
      })

      currentBtn = btn
      currentContent = contents[index]
    })
  })
}
